import classNames from 'classnames/bind';
import React from 'react';

import styles from './RobotThumbnail.module.scss';

import MODELS from '@/models';

const cx = classNames.bind(styles);

const RobotThumbnail = ({ robot, className, style }) => {
  const thumbnail = MODELS[robot.model.id]?.thumbnail;

  return (
    <div className={cx(['container', className])} style={style}>
      {!thumbnail && <div className={cx('initial')}>{robot.name[0]}</div>}
      {thumbnail && <img src={thumbnail} width="100%" alt={robot.model.name} />}
    </div>
  );
};

export default RobotThumbnail;
